import { Box } from '@mui/material'
import { cx } from '@emotion/css'
import React, { Children } from 'react'
import MainSlider from '../../../../../../organisms/main-slider'
import { Slide } from '../../../../../slider'

const SliderRenderer = ({ aboveTheFold, minHeight, sliderSettings, sx, cssProp, className, children }) => {
	return (
		<Box
			className={cx('Magento-PageBuilder-Slider', className)}
			sx={{ ...sx, minHeight, width: '100%', height: aboveTheFold ? '100%' : undefined }}
			css={cssProp}
		>
			<MainSlider aboveTheFold={aboveTheFold} {...sliderSettings}>
				{Children.map(children, (child) => {
					if (child?.props?.data) {
						child.props.data.aboveTheFold = aboveTheFold
					}
					return <Slide aboveTheFold={aboveTheFold}>{child}</Slide>
				})}
			</MainSlider>
		</Box>
	)
}

export default SliderRenderer
